// angular
import { Component, Input, OnDestroy, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../../core/core.service';

// others
import { AppService } from '../../../app.service';
import { AuthService } from '../../../core/auth.service';
import { BannersService } from '../banners.service';
import { Router } from '@angular/router';
import { BannersComponent } from '../banners.component';
import * as moment from 'moment';
import { KlenicoMeService } from '../../me.service';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'me-nps',
    templateUrl: './nps.component.html',
    styleUrls: ['./nps.component.scss'],
    providers: [BannersService]
})

export class MeNPSComponent extends BannersComponent implements OnInit {
    data: any;
    storyBlock = 'test-user';
    score = 0;
    comment = '';
    commentSection = false;
    notification;
    nps;

    @Input() callApi = true;
    @Input() blockData = false;
    @Input() slug: string;


    @ViewChild('modal',  {static: false}) modal: ModalDirective;

    constructor(
        public appService: AppService,
        public fb: FormBuilder,
        public translate: TranslateService,
        public coreService: CoreService,
        public router: Router,
        public bannerService: BannersService,
        public authService: AuthService,
        public meService: KlenicoMeService
    ) {
        super(appService, translate, coreService, router, bannerService, authService, meService);
    }

    ngOnInit() {
        this.patientId = this.authService.patientId;
        
        if (this.callApi) {
            this.url = this.url + '/' + this.slug;
            this.getContent();
            this.translate.onLangChange.subscribe(value => {
                this.getContent();
            });
        } else {
            this.data = this.blockData['content'];
        }
    }

    ngAfterViewInit() {
        this.modal.config.backdrop = false;
        this.modal.config.ignoreBackdropClick = true;
        this.modal.config.keyboard = false;
    }

    checkShowNPSModal(notification, nps) {
        this.notification = notification;
        if (!this.data || !this.data.delay || this.data.delay === '') {
            this.modal.show();
            return;
        }

        let now = moment(moment.utc().format('YYYY-MM-DD hh:mm:ss')).add('1', 'hours'); //Zurich time
        let validAt = moment(notification.valid_at);
        if (now.diff(validAt, 'minutes') >= this.data.delay) {
            this.modal.show();
        }

        if (nps) {
            this.commentSection = true;
        }
    }

    setRating(i) {
        this.score = i;
    }

    next() {
        if (!this.score) {
            return;
        }

        this.appService.isLoading = true;
        this.bannerService.sendNPS({
            score: this.score,
            patient_id: this.patientId
        }).subscribe(res => {
            this.commentSection = true;
            this.nps = res['data'];
            this.appService.isLoading = false;
        });

        this.commentSection = true;
    }

    submit() {
        this.appService.isLoading = true;
        this.bannerService.sendNPS({
            comment: this.comment,
            patient_id: this.patientId,
            id: this.nps.id
        }).subscribe(res => {
            this.closeModal(true);
            this.appService.isLoading = false;
        });
    }

    closeModal(sendNPS = false) {
        this.bannerService.updateNotificationProcessed({
            showOnce : sendNPS ? true : this.data.showOnce,
            processed: true,
            type: this.data.trigger
        }).subscribe(res => {
            this.modal.hide();
        })
    }
}
